var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('EditSupplier',{attrs:{"supplierId":_vm.supplierId},on:{"editDetail":_vm.editSupplier,"cancelEdit":_vm.cancelEdit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }